import {FC, ReactNode} from "react";
import {FlexSpace, Row} from "../atoms/Layout.tsx";
import Logo from "../atoms/Logo.tsx";
import {Text} from "../style/typography.tsx";
import {ArrowLeftIcon} from "../atoms/Icon";
import {useNavigate} from "react-router";

interface Props {
    title?: string;
    backTo?: string;
    children?: ReactNode;
}

const AppBar: FC<Props> = ({title, backTo, children}) => {
    const navigate = useNavigate();

    return <Row padding="20" gap="20" centerVertically>
        { !backTo && <Logo /> }
        { backTo && <ArrowLeftIcon size={20} onClick={() => navigate(backTo)} /> }
        {title && <>
            <Text role="body" size="1" weight="medium" overflow="truncate">
                {title}
            </Text>
            <FlexSpace />
        </>}
        <FlexSpace />
        {children}
    </Row>
}

export default AppBar;